import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { selectIsAuthenticated, selectAbility, selectUser } from '../../redux/slices/authSlice'
import { addAuditLog } from '../../redux/slices/auditSlice'
import { ROUTE_ABILITY_MAP } from '../../utility/context/ability'
import LayoutWrapper from '../../@core/layouts/components/layout-wrapper'

const AuthGuard = ({ component: Component, routeMeta, action, subject }) => {
  const dispatch        = useDispatch()
  const location        = useLocation()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const ability         = useSelector(selectAbility)
  const user            = useSelector(selectUser)

  const mapped     = ROUTE_ABILITY_MAP[location.pathname] || {}
  const reqAction  = action  || mapped.action  || 'read'
  const reqSubject = subject || mapped.subject || 'Dashboard'

  useEffect(() => {
    if (isAuthenticated && user) {
      dispatch(addAuditLog({ action: 'PAGE_VISIT', subject: reqSubject, meta: { path: location.pathname } }))
    }
  }, [location.pathname]) // eslint-disable-line

  if (!isAuthenticated)
    return <Navigate to="/login" state={{ from: location }} replace />

  if (!ability.can(reqAction, reqSubject)) {
    dispatch(addAuditLog({ action: 'ACCESS_DENIED', subject: reqSubject, meta: { path: location.pathname, role: user?.role } }))
    return <Navigate to="/auth/not-auth" replace />
  }

  return (
    <LayoutWrapper routeMeta={routeMeta}>
      <Component />
    </LayoutWrapper>
  )
}

export default AuthGuard